import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  template: '',
})
export class CardTableCustomCellBaseComponent {
  @ViewChild(TemplateRef, { static: true, read: TemplateRef }) templateRef: TemplateRef<unknown>;
  @Input() columnKey: string;
}
